import React from 'react'
import styled from 'styled-components'
import { MqTablet, MqDesktop } from 'streamr-ui/css/consts'
import Container from '~shared/Container'

const Wrapper = styled.div`
    color: #323232;
    font-size: 16px;

    p,
    h1,
    h2 {
        line-height: 1.5em;
        margin: 0;
        padding: 0;
    }

    h1 {
        color: #0c009a;
        font-size: 28px;
        line-height: 1.4em;
        margin-bottom: 0.125em;
        font-weight: 400;
    }

    h2 {
        color: #a3a3a3;
        font-size: 10px;
        font-weight: 500;
        letter-spacing: 1px;
        text-transform: uppercase;
    }

    @media ${MqTablet} {
        font-size: 18px;
        text-align: center;

        h1 {
            font-size: 32px;
        }

        h2 {
            font-size: 12px;
        }
    }

    @media ${MqDesktop} {
        font-size: 20px;

        h1 {
            font-size: 40px;
        }

        h2 {
            font-size: 14px;
            letter-spacing: 2px;
        }
    }
`

const CaseStudyTitle = ({ name, summary, ...props }) => (
    <Wrapper {...props}>
        <Container $appearIntersection>
            <h1 $appear>{`Case Study — ${name}`}</h1>
            <h2 $appear>{summary}</h2>
        </Container>
    </Wrapper>
)

export default CaseStudyTitle
